import React from "react";
import { Button, Box, Typography, IconButton, Drawer } from "@mui/material";
import { Menu, HighlightOff } from "@mui/icons-material";
import { Link } from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import "./Navbar.css";

const Navbar = () => {
  const [open, setopen] = React.useState(false); //state for open/close the right Drawer
  React.useEffect(() => {
    const handleClick = () => {
      const section = document.getElementById('work');
      section.scrollIntoView({ behavior: 'smooth' });
    };
    const link = document.getElementById('scroll-link');
    link.addEventListener('click', handleClick);

    return () => {
      link.removeEventListener('click', handleClick);
    };
  }, []);


  React.useEffect(() => {
    const handleClick = () => {
      const section = document.getElementById('powerform');
      section.scrollIntoView({ behavior: 'smooth' });
    };
    const link = document.getElementById('scroll-link2');
    link.addEventListener('click', handleClick);

    return () => {
      link.removeEventListener('click', handleClick);
    };
  }, []);


  React.useEffect(() => {
    const handleClick = () => {
      const section = document.getElementById('pricing');
      section.scrollIntoView({ behavior: 'smooth' });
    };
    const link = document.getElementById('scroll-link3');
    link.addEventListener('click', handleClick);

    return () => {
      link.removeEventListener('click', handleClick);
    };
  }, []);

  React.useEffect(() => {
    const handleClick = () => {
      const section = document.getElementById('pricing');
      section.scrollIntoView({ behavior: 'smooth' });
    };
    const link = document.getElementById('scroll-link4');
    link.addEventListener('click', handleClick);

    return () => {
      link.removeEventListener('click', handleClick);
    };
  }, []);
  React.useEffect(() => {
    const handleClick = () => {
      const section = document.getElementById('testominals');
      section.scrollIntoView({ behavior: 'smooth' });
    };
    const link = document.getElementById('scroll-link4');
    link.addEventListener('click', handleClick);

    return () => {
      link.removeEventListener('click', handleClick);
    };
  }, []);
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        padding: "15px",
        bgcolor: "rgb(10,77,170)",
        color: "white",
      }}
    >
      {/* Right Drawer start*/}
      <Drawer anchor={"right"} open={open} onClose={() => setopen(false)}>
        <Box
          sx={{
            bgcolor: "rgb(10,77,170)",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            p: 3,
          }}
        >
          <IconButton
            sx={{ position: "absolute", top: 0, right: 5 }}
            onClick={() => setopen(!open)}
          >
            <HighlightOff sx={{ color: "white" }} />
          </IconButton>
          <List>
            <ListItem>
              <ListItemButton>
                <Box sx={{ cursor: "pointer" }}>
                  <img src="logo.svg" />
                </Box>
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  How It Works
                </Link>
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Form-AI
                </Link>
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Pricing
                </Link>
              </ListItemButton>
            </ListItem>

            <ListItem>
              <ListItemButton>
                <Link
                  to={"#"}
                  style={{ textDecoration: "none", color: "white" }}
                >
                  Testominals
                </Link>
              </ListItemButton>
            </ListItem>

            <ListItem sx={{ width: "100%" }}>
              <ListItemButton>
                <Button
                  size="small"
                  sx={{
                    bgcolor: "white",
                    color: "rgb(10,77,170)",
                    px: 4,
                    height: 35,
                    width: "100%",
                    ":hover": {
                      bgcolor: "white",
                      color: "rgb(10,77,170)",
                    },
                  }}
                >
                  Log In
                </Button>
              </ListItemButton>
            </ListItem>
          </List>
        </Box>
      </Drawer>
      {/* Right Drawer End*/}

      <Box sx={{ ml: 6, cursor: "pointer" }}>
        <img src="logo.svg" />
      </Box>
      {/* links section */}
      <Box
        sx={{
          width: "45%",
          display: "flex",
          justifyContent: "space-around",
          display: {
            xs: "none",
            sm: "none",
            md: "flex",
            lg: "flex",
            xl: "flex",
          },
        }}
      >
        <Link to={'#'} id="scroll-link" style={{ textDecoration: "none", color: "white" }}>
          How It Works
        </Link>
        <Link to={"#"} id="scroll-link2" style={{ textDecoration: "none", color: "white" }}>
          Form-AI
        </Link>
        <Link to={"#"} id="scroll-link3" style={{ textDecoration: "none", color: "white" }}>
          Pricing
        </Link>
        <Link to={"#"} id="scroll-link4" style={{ textDecoration: "none", color: "white" }}>
          Testominals
        </Link>
      </Box>
      {/* login button section */}
      <Box
        sx={{
          mr: 6,
          display: {
            xs: "none",
            sm: "none",
            md: "inline",
            lg: "inline",
            xl: "inline",
          },
        }}
      >
        <Button
          size="small"
          sx={{
            bgcolor: "white",
            color: "rgb(10,77,170)",
            px: 4,
            height: 35,
            ":hover": {
              bgcolor: "white",
              color: "rgb(10,77,170)",
            },
          }}
        >
          Log In
        </Button>
      </Box>
      {/* Icon menu */}
      <Box
        sx={{
          display: {
            xs: "inline",
            sm: "inline",
            md: "none",
            lg: "none",
            xl: "none",
          },
        }}
      >
        <IconButton onClick={() => setopen(!open)}>
          <Menu sx={{ color: "white" }} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Navbar;
